import React, { useState, useEffect } from "react";
import {
  Container,
  makeStyles,
  Grid,
  Breadcrumbs,
  Link,
  Typography,
  Paper,
} from "@material-ui/core";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { useParams, useHistory } from "react-router-dom";
import Skeleton from "@material-ui/lab/Skeleton";

import { getUserListPointsLog } from "../../api/Points";

const { forwardRef } = React;
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    [theme.breakpoints.up("lg")]: {
      paddingLeft: "190px",
    },
  },
  exportButtonProgress: {
    position: "absolute",
    marginTop: 5,
    marginLeft: 5,
  },
}));
const height = window.innerHeight;

const PointLogDetails = forwardRef(() => {
  const classes = useStyles();
  const history = useHistory();
  let { client_id, id } = useParams();
  const [pointDetails, setPointDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (id) {
      // Recover pointLog from localStorage
      const pointLog = JSON.parse(localStorage.getItem(`pointLog`));
      setPointDetails(pointLog);
      if (pointLog) {
        const pointsIds = pointLog.pointsIds
          .map((point) => point.id)
          .join(", ");
        getListUsers(pointsIds);
        setLoading(false);
      }
    }
    // Clean the localStorage after the component is unmounted
    return () => {
      localStorage.removeItem(`pointLog`);
    };
  }, [id]);

  /**
   *  Fetches the list of users who have received points based on the provided point IDs.
   * @param {*} pointsIds
   */
  const getListUsers = (pointsIds) => {
    getUserListPointsLog(pointsIds)
      .then((response) => {
        if (response.errors) {
          console.error("Error fetching user points log:", response.errors);
        } else {
          // Process the response data as needed
          const data = response.data.getPointsById;
          let listUsers = [];
          for (const element of data) {
            const user = {
              id: element.id,
              username: element.user_id.username,
              points: element.TransactionAmount,
              // amount: points?.TransactionAmount || "pending",
              date: element.created_at,
            };
            listUsers.push(user);
          }
          setUsers(listUsers);
        }
      })
      .catch((error) => {
        console.error("Error fetching user points log:", error);
      });
  };

  return (
    <Container
      style={{ marginTop: "65px" }}
      className={classes.mainContainer}
      maxWidth="xl"
    >
      <Grid
        container
        spacing={4}
        style={{ padding: "20px" }}
        id="point_log_details"
      >
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            <Link
              color="textSecondary"
              onClick={() =>
                history.push(`/app/client/${client_id}/points_log`)
              }
              style={{ cursor: "pointer" }}
            >
              Points log
            </Link>
            <Typography color="textSecondary">Manage point</Typography>
          </Breadcrumbs>
        </Grid>
        {loading ? (
          <>
            <Grid item xs={12} md={6} lg={6}>
              <Paper
                variant="outlined"
                className={classes.paper}
                style={{ paddingLeft: "10px", paddingBottom: "20px" }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <Skeleton height={40} />
                  </Grid>
                  <Grid item xs={8}></Grid>
                </Grid>

                {[1, 2, 3, 4].map((item, index) => (
                  <Grid container key={index}>
                    <Grid item xs={3}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={3}></Grid>
                    <Grid item xs={3}>
                      <Skeleton height={40} />
                    </Grid>
                  </Grid>
                ))}
              </Paper>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Paper
                variant="outlined"
                className={classes.paper}
                style={{ paddingLeft: "10px", paddingBottom: "20px" }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Skeleton height={40} />
                  </Grid>
                  <Grid item xs={8}></Grid>
                </Grid>
                {new Array(10).fill(null).map((_, index) => (
                  <Grid container key={index}>
                    <Grid item xs={2}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={1}></Grid>

                    <Grid item xs={1}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={2}></Grid>

                    <Grid item xs={2}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={1}></Grid>

                    <Grid item xs={2}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={1}></Grid>
                  </Grid>
                ))}
              </Paper>
            </Grid>
          </>
        ) : (
          <>
            {/* Manage Points */}
            <Grid item xs={12} md={6} lg={6}>
              <Paper variant="outlined" className={classes.paper}>
                {/**User profile title*/}
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{ paddingLeft: "10px" }}
                >
                  MANAGE POINTS
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      <b>Assigned by</b>
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      {pointDetails.assigned_by}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      <b> Add or reset</b>
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      {pointDetails.Type == "AddPoints" ? "Add" : "Reset"}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      <b>Points</b>
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      {pointDetails.points}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      <b>Date</b>
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      {pointDetails.date}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      <b>Division category</b>
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      {pointDetails.division}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      <b>Frecuency</b>
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      {pointDetails.repeat
                        ? pointDetails.repeat
                        : "No repetition"}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      <b>Note</b>
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      {pointDetails.note ? pointDetails.note : "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            {/* User whith points applied */}
            <Grid item xs={12} md={6} lg={6}>
              <Paper
                variant="outlined"
                className={classes.paper}
                style={{
                  maxHeight: height - 250,
                }}
              >
                {/**User List*/}
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{ paddingLeft: "10px" }}
                >
                  USER WITH POINTS APPLIED
                </Typography>

                {/* List Users headers*/}
                <Grid container spacing={2}>
                  <Grid item xs={3} md={3} lg={3}>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      <b>USERS</b>
                    </Typography>
                  </Grid>
                  <Grid item xs={3} md={3} lg={3}>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      <b>POINTS</b>
                    </Typography>
                  </Grid>
                  <Grid item xs={3} md={3} lg={3}>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      <b>ASSIGNED BY</b>
                    </Typography>
                  </Grid>
                  <Grid item xs={3} md={3} lg={3}>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      style={{ paddingLeft: "10px" }}
                    >
                      <b>DATE</b>
                    </Typography>
                  </Grid>
                </Grid>

                {/* Mapear los usuarios */}
                <Grid
                  style={{
                    maxHeight: height - 370,
                    overflowY: "auto",
                    overflowX: "hidden",
                    padding: "7px 0px",
                  }}
                >
                  {users.map((user, index) => (
                    <Grid key={index} container spacing={1}>
                      <Grid item xs={3} md={3} lg={3}>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ paddingLeft: "10px" }}
                          noWrap
                        >
                          {user.username}
                        </Typography>
                      </Grid>
                      <Grid item xs={3} md={3} lg={3}>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ paddingLeft: "10px" }}
                        >
                          {user.points}
                        </Typography>
                      </Grid>
                      <Grid item xs={3} md={3} lg={3}>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ paddingLeft: "10px" }}
                          noWrap
                        >
                          {pointDetails.assigned_by}
                        </Typography>
                      </Grid>
                      <Grid item xs={3} md={3} lg={3}>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ paddingLeft: "10px" }}
                        >
                          {new Date(user.date).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          })}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Paper>
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
});

PointLogDetails.displayName = "PointLogDetails";

export default PointLogDetails;
